import { useQuery } from '@tanstack/react-query';
import { fetchApdexConfig } from '../services/apdex';

export function useValidateApdexConfig({ objetivoId }) {
  return useQuery({
    queryKey: ['validateApdexConfig', objetivoId],
    queryFn: async () => fetchApdexConfig({ objetivoId }),
    enabled: !!objetivoId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
